import { API } from 'aws-amplify';
import {
  API_DATA_REQUESTED,
  API_ERROR,
  ELEVATION_HAZARDS_RECEIVED,
  CLEAR_ELEVATION_HAZARDS
} from './actionTypes';

import { requestOptions } from '../constants';

const options = requestOptions;

export const clearElevationHazards = (): ((dispatch: any) => void) => dispatch =>
  dispatch({
    type: CLEAR_ELEVATION_HAZARDS
  });

/**
 * Fetches elevation hazards for a specific landing pad by its ID
 * @param originLandingPadId - The ID of the origin landing pad
 * @returns A GeoJSON FeatureCollection containing elevation hazard polygons
 */
export const getElevationHazards = (
  originLandingPadId: string
): ((dispatch: any) => Promise<void>) => async (dispatch) => {
  dispatch({ type: API_DATA_REQUESTED });

  try {
    const result = await API.get('flightapi', `/elevation/hazardsRelativeTo?padId=${originLandingPadId}&merge=true`, options);

    dispatch({
      type: ELEVATION_HAZARDS_RECEIVED,
      payload: result,
    });

  } catch (err) {
    dispatch({
      type: API_ERROR,
      payload: err,
    });
  }
};

